import { Component, computed, input, OnInit, viewChild } from '@angular/core';
import { WindowRefService } from '../../../../services/window-ref.service';
import { AuthLinkType } from '../../../../enums/event/event-data.enum';
import { SlideOutService } from '../../../customer-hub/services/slide-out.service';
import { RedirectService } from '../../../redirect/services/redirect.service';
import { ElementScreenSizeDirective } from '../../../shared/directives/element-screen-size.directive';
import { DomService } from '../../../shared/services/dom.service';
import {
  isSecondLoanOrIta,
  Offer,
  OfferKey,
  shouldShowMinAprInTitle as offerShowsMinAprInTitle,
  OfferType,
  SubProductType,
} from '../../models/offers.model';
import { OffersService } from '../../services/offers.service';

@Component({
  selector: 'app-loan-offer',
  templateUrl: './loan-offer.component.html',
  styleUrls: ['./loan-offer.component.scss'],
  standalone: false,
})
export class LoanOfferComponent implements OnInit {
  readonly offer = input.required<Offer>();
  readonly isInCarousel = input<boolean>(false);

  private readonly elementScreenSize = viewChild(ElementScreenSizeDirective);

  readonly isContainerMobile = computed(() => {
    const d = this.elementScreenSize();
    return d ? d.isMobile() : false;
  });

  readonly showsMinAprInTitle = computed(() => offerShowsMinAprInTitle(this.offer()));
  readonly isResumeStyleOffer = computed(() => {
    const offer = this.offer();
    return (
      offer?.offerType === OfferType.RESUME_APPLICATION ||
      offer?.offerKey === OfferKey.OFFERS_RESUMABLE_APP
    );
  });

  readonly isSecuredLoanOffer = computed(() => this.offer().subProductType === SubProductType.SECURED_HOME_LOAN);

  constructor(
    private readonly offersService: OffersService,
    private readonly redirectService: RedirectService,
    private readonly windowRefService: WindowRefService,
    private readonly slideOutService: SlideOutService,
    private readonly domService: DomService
  ) {}

  ngOnInit(): void {
    const offer = this.offer();

    if (isSecondLoanOrIta(offer)) {
      const EVENT = '[Auth] Offers 2nd loan offer seen';
      this.windowRefService.nativeWindow.FS.event(EVENT);
    } else if (offer?.offerType === OfferType.RESUME_APPLICATION) {
      const EVENT = '[Auth] Offers 2nd resumable app link seen';
      this.windowRefService.nativeWindow.FS.event(EVENT);
    }

    if (!this.isInCarousel()) {
      this.offersService.trackSeenEvent({
        offer,
        placement: '_CAROUSEL',
        siteSection: 'hub',
      });
    }

    const utmCampaign = new URL(offer.offerUrl).searchParams.get('utm_campaign');
    if (utmCampaign) {
      this.redirectService.dropToCookie('be_pl_2nd_offer_campaign', utmCampaign, 60);
    }
  }

  clickResumeApplication(): void {
    this.offersService.trackLinkClickEvent({
      offer: this.offer(),
      placement: '_CAROUSEL',
      siteSection: 'hub',
      fsEvent: '[Auth] Offers 2nd resumable app link clicked',
    });
  }

  onGetOffer(): void {
    this.offersService.trackLinkClickEvent({
      offer: this.offer(),
      placement: '_CAROUSEL',
      siteSection: 'hub',
      fsEvent: '[Auth] Offers 2nd loan offer clicked',
    });
  }

  onDisclosureClick(): void {
    const offer = this.offer();
    if (offer?.offerType !== OfferType.RESUME_APPLICATION) {
      this.offersService.openDisclosures(offer.subProductType);
      return;
    }
    if (offer?.offerType === OfferType.RESUME_APPLICATION) {
      this.clickResumeApplication();
    }
  }

  openSlideOut(offer: Offer): void {
    if (offer.subProductType === 'SECURED_HOME_LOAN') {
      this.slideOutService.open('hsl', offer, '_CAROUSEL');
      this.offersService.trackLearnMoreClick(AuthLinkType.OPEN_HSL_SLIDE_OUT);
    }
  }
}
